<template>
  <div id="investment" class="site-container">
    <h1>Invest in Your Memories</h1>

    <div class="pricing-section">
      <section id="weddings">
        <h2>Weddings</h2>

        <div class="pricing-boxes">
          <div class="pricing-box">
            <div class="image image-weddings-full"></div>
            <div class="package">
              <h6>
                <span>Starting at</span>
                <span><span class="small">$</span>3,000</span>
              </h6>

              <ul>
                <li>Up to 10 hours</li>
                <li>Complimentary engagement session</li>
                <li>Online gallery</li>
                <li>USB drive with all photos</li>
                <li>Set of 25 4x5 print photos</li>
              </ul>
            </div>
          </div>
        </div>

        <p class="pricing-note">
          *For weddings with more than 100 guests, a second photographer is required,
          and an additional fee of $450 will be added to the final price.
        </p>
      </section>

      <section id="elopements">
        <h2>Elopements</h2>

        <div class="pricing-boxes">
          <div class="pricing-box">
            <div class="image image-elopements-standard"></div>
            <div class="package">
              <h6>
                <span>Standard</span>
                <span><span class="small">$</span>350<span class="small">/hr</span></span>
              </h6>

              <ul>
                <li>2 hours minimum</li>
                <li>Online gallery</li>
              </ul>
            </div>
          </div>
        </div>

        <p class="pricing-note">
          *Out of state and destination weddings and elopements available.
        </p>
      </section>

      <section>
        <h2>Engagements</h2>

        <div class="pricing-boxes">
          <div class="pricing-box">
            <div class="image image-engagements-standard"></div>
            <div class="package">
              <h6>
                <span>Standard</span>
                <span><span class="small">$</span>395</span>
              </h6>

              <ul>
                <li>1 hour</li>
                <li>2 locations</li>
                <li>Change of clothes</li>
                <li>Online gallery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2>Families</h2>

        <div class="pricing-boxes">
          <div class="pricing-box">
            <div class="image image-families-standard"></div>
            <div class="package">
              <h6>
                <span>Standard</span>
                <span><span class="small">$</span>345</span>
              </h6>

              <ul>
                <li>1 hour</li>
                <li>Online gallery</li>
                <li>50 edited high resolution photos</li>
                <li>Contact me for extended family</li>
                <li>All pets always welcome (as long as location allows them)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="headshots">
        <h2>Headshots & Lifestyle</h2>

        <div class="pricing-boxes">
          <div class="pricing-box">
            <div class="image image-headshots"></div>
            <div class="package">
              <h6>
                <span>Headshots</span>
                <span><span class="small">$</span>350</span>
              </h6>

              <ul>
                <li>30 minutes</li>
                <li>5 edited high resolution photos</li>
                <li>Online gallery</li>
              </ul>
            </div>
          </div>

          <div class="pricing-box">
            <div class="image image-lifestyle"></div>
            <div class="package">
              <h6>
                <span>Lifestyle</span>
                <span><span class="small">$</span>450</span>
              </h6>

              <ul>
                <li>1 hour</li>
                <li>10-15 edited high resolution photos</li>
                <li>Online gallery</li>
              </ul>
            </div>
          </div>

          <div class="pricing-box">
            <div class="image image-company"></div>
            <div class="package">
              <h6>
                <span>Company</span>
                <router-link :to="{ name: 'contact' }">Contact me</router-link>
              </h6>

              <ul>
                <li>5 edited high resolution photos per employee</li>
                <li>Online gallery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <router-link :to="{ name: 'contact' }" id="letsConnectBtn">Let's Connect</router-link>

      <p class="pricing-note emphasize">*Prices subject to change. Additional fees may apply for travel outside of the
        Austin area.</p>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'investment',
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>